import { useState, Fragment, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { sendReset, alertMessage } from "../actions/auth";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Card from "@mui/material/Card";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IconButton from "@mui/material/IconButton";
import { themeStyle, themeStyleDark } from "../components/Components";
import clip from "../img/bg.mp4";

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);

  const [email, setEmail] = useState("");
  const [showSnack, setShowSnack] = useState(false);
  const [snack, setSnack] = useState("");

  useEffect(() => {}, []);

  function onSubmit(e) {
    e.preventDefault();
    dispatch(sendReset(email));
  }

  if (state.auth.alert) {
    if (state.auth.alert.title === "Email Sent.") {
      setSnack({
        title: state.auth.alert.title,
        message: state.auth.alert.message,
        type: state.auth.alert.type,
      });
      setShowSnack(true);
      dispatch({ type: "REMOVE_ALERT" });
      setTimeout(() => navigate("/reset-password/"), 1500);
    } else {
      setSnack({
        title: state.auth.alert.title,
        message: state.auth.alert.message,
        type: state.auth.alert.type,
      });
      setShowSnack(true);
      dispatch({ type: "REMOVE_ALERT" });
    }
  }

  if (state.auth.isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        autoHideDuration={6000}
        open={showSnack}
        onClose={() => setShowSnack(false)}
      >
        <Card style={{ minWidth: "36vh", padding: "10px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }}>
              {snack["type"] === "SUCCESS" ? (
                <CheckCircleIcon
                  style={{
                    color:
                      state.auth.theme === "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontSize: "44px",
                  }}
                />
              ) : (
                <ErrorIcon style={{ color: "#ff3333", fontSize: "44px" }} />
              )}
              <div style={{ marginLeft: "10px" }}>
                <b style={{ fontSize: "15px" }}>{snack["title"]}</b>
                <br />
                <span>{snack["message"]}</span>
              </div>
            </div>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setShowSnack(false)}
                style={{
                  color:
                    state.auth.theme === "dark"
                      ? themeStyleDark.primaryButtonColor
                      : themeStyle.primaryButtonColor,
                }}
              />
            </IconButton>
          </div>
        </Card>
      </Snackbar>

      <div
        style={{
          zIndex: 10,
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "opacity 1s",
          backgroundImage:
            "linear-gradient(to right, rgba(0,0,0,0.9), rgba(0,0,0,0.9))",
        }}
      >
        <video
          style={{ zIndex: 0, position: "absolute" }}
          id="background-video"
          autoPlay
          loop
          muted
        >
          <source src={clip} type="video/mp4" />
        </video>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundImage:
              "linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))",
            height: "100%",
            flexDirection: "column",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            zIndex: 2,
          }}
        >
          <div
            style={{
              zIndex: 2,
              boxShadow: "0 8px 18px 0 rgba(0,0,0,0.2)",
              padding: "2.2vh",
              borderRadius: "6px",
              backgroundColor:
                state.auth.theme === "dark"
                  ? themeStyleDark.primaryCardColor
                  : themeStyle.primaryCardColor,
              paddingRight: "2.2vh",
              maxWidth: "400px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                color:
                  state.auth.theme === "dark"
                    ? themeStyleDark.textColor
                    : themeStyle.textColor,
              }}
            >
              <div style={{ marginTop: "-7px", textAlign: "left" }}>
                <span
                  style={{
                    fontSize: "25px",
                    fontWeight: "bold",
                    color:
                      state.auth.theme === "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                  }}
                >
                  Forgot Password
                </span>
                <br />
                <span
                  style={{
                    fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                    color:
                      state.auth.theme === "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                  }}
                >
                  Enter your email and we'll send you a reset code.
                </span>
              </div>
              <img
                style={{ maxHeight: "10vh", borderRadius: 15 }}
                src={require("../img/footor-logo.png")}
                alt="Riches Media Digital Logo"
              />
            </div>

            <div style={{ margin: "20px 0px 0px 0px" }}>
              <form onSubmit={onSubmit}>
                <TextField
                  style={{
                    backgroundColor:
                      state.auth.theme === "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme === "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  placeholder="E-Mail"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <div style={{ marginTop: "10px", textAlign: "center" }}>
                  <Link
                    style={{
                      color:
                        state.auth.theme === "dark"
                          ? themeStyleDark.textColor
                          : themeStyle.textColor,
                    }}
                    to="/login/"
                  >
                    Back to Login
                  </Link>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2.2vh",
                  }}
                >
                  <Button
                    style={{
                      height: "30px",
                      backgroundColor:
                        state.auth.theme === "dark"
                          ? themeStyleDark.primaryButtonColor
                          : themeStyle.primaryButtonColor,
                      color:
                        state.auth.theme === "dark"
                          ? themeStyleDark.primaryButtonTextColor
                          : themeStyle.primaryButtonTextColor,
                    }}
                    type="submit"
                    variant="contained"
                  >
                    <span style={{ fontSize: "18px", width: "140px" }}>
                      Send Reset Code
                    </span>
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Box style={{ position: "absolute", right: 20, bottom: 20 }}>
          <div style={{ color: "white" }}>
            {"Copyright © "}
            Riches Media Digital 2026
            {"."}
          </div>
        </Box>
      </div>
    </Fragment>
  );
}
